export const formatBalanceAccounts = (accounts) => {
  const formattedAccounts = accounts.reduce((acc, account) => {
    acc.push({
      label: `${account.accountCurrency} | ${account.accountNumber}`,
      value: account.accountNumber,
      currency: account.accountCurrency,
      balance: account.balance,
    });

    return acc;
  }, []);

  return formattedAccounts;
};
